import { connect } from 'react-redux';
import { fetchTypologies } from '../../../redux/actions/trm/trmDashboard';
import TypologyListingDashboard from './TypologyListingDashboard';

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{typologyListingDashboard: trmDashboard}}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    trmDashboard: state.trmDashboard,
    authentication: state.authentication.data,
    authenticationStateObject: state.authentication
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    fetchTypologiesData: (payload) => {
      dispatch(fetchTypologies(payload));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TypologyListingDashboard);
